<template>
  <div class="header-container">
    <div class="l-content">
      <el-button
        type="primary"
        icon="el-icon-menu"
        size="mini"
        @click="collapseMenu"
      ></el-button>
      <!-- 面包屑组件 -->
      <BreadcrumbNav></BreadcrumbNav>
    </div>
    <div class="r-content">
      <!-- <el-badge is-dot class="item"
        ><i class="el-icon-message-solid icon-msg" @click="toNoticePage"></i
      ></el-badge> -->

      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <el-avatar
            src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
          >
            <!-- 当avatar中的链接访问不到时，展示img中图片 -->
            <img
              src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"
            />
          </el-avatar>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="userinfo">个人中心</el-dropdown-item>
          <el-dropdown-item divided command="exit">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="80%">
      <div ref="divRef" style="height: 600px" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { AiEditor } from "aieditor";
import "aieditor/dist/style.css";

import Cookie from "js-cookie";
import BreadcrumbNav from "./BreadcrumbNav.vue";

import { mapMutations } from "vuex";

export default {
  name: "CommonHeader",
  components: { BreadcrumbNav },
  data() {
    return {
      dialogVisible: false,
      aiEditor: null
    };
  },
  methods: {
    ...mapMutations("tab", ["collapseMenu",'selectMenu']),
    handleCommand(command) {
      if (command === "exit") {
        Cookie.remove("token");
        Cookie.remove("userName");
        Cookie.remove("menu");
        this.$router.push("/login");
        //清除当前角色路由权限
        this.$router.resetRouter();
        //清除tag
        this.$store.commit("tab/resetMenu");
      }else if(command === "userinfo"){
        this.$router.push({name:"userinfo"});
        this.selectMenu({"path":"/userinfo","name":"userinfo","label":"个人中心","url":"UserInfo.vue","hinde":true})
      }
    },
    toNoticePage() {
      this.dialogVisible = true;
      // this.$message.info("功能开发中");
    },
  },
  watch: {
    dialogVisible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (newVal) {
            if (!this.aiEditor) {
              this.aiEditor = new AiEditor({
                element: this.$refs.divRef,
                placeholder: "点击输入内容...",
                content: "AiEditor 是一个面向 AI 的开源富文本编辑器。 ",
              });
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header-container {
  background-color: #333;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;

  .l-content {
    display: flex;
    align-items: center;

    .el-breadcrumb {
      font-size: 14px;
      margin-left: 10px;
    }
  }

  .r-content {
    display: flex;
    align-items: center;

    .item {
      margin-top: 10px;
      margin-right: 20px;
    }
    .icon-msg {
      font-size: 22px;
      cursor: pointer;
      color: grey;
    }
  }
}
</style>